import axios from 'axios'
import { Toast } from 'vant'
import router from '../router'
import {baseURL} from './config'
// axios.defaults.baseURL="http://localhost:5000/api"
// 创建axios实例
const service = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 统一添加token
    const token = localStorage.getItem('userToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 业务状态码判断
    if (res.code !== 200) {
      // 401: 未登录或token过期（全局处理）
      if (res.code === 401) {
        localStorage.removeItem('userToken')
        localStorage.removeItem('userInfo')
        Toast.fail(res.msg || '登录已过期，请重新登录')
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
      }
      // 用户不存在（用户被删除等情况），清除登录状态并跳登录页
      else if (res.msg && (res.msg.includes('用户不存在') || res.msg.includes('用户已被删除'))) {
        localStorage.removeItem('userToken')
        localStorage.removeItem('userInfo')
        Toast.fail('登录状态已失效，请重新登录')
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
      }
      // 业务错误由各调用方自行处理提示，避免重复弹窗
      const err = new Error(res.msg || '请求失败')
      err.code = res.code
      err.data = res.data
      return Promise.reject(err)
    }
    return res.data;
  },
  error => {
    console.error('响应错误:', error)
    if (error.response) {
      const { status, data } = error.response
      switch (status) {
        case 401:
          localStorage.removeItem('userToken')
          localStorage.removeItem('userInfo')
          Toast.fail('登录已过期，请重新登录')
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          })
          break
        case 403:
          Toast.fail('没有权限访问')
          break
        case 404:
          Toast.fail('请求资源不存在')
          break
        case 500:
          Toast.fail('服务器内部错误')
          break
        default:
          Toast.fail(data?.msg || `请求失败(${status})`)
      }
    } else if (error.message.includes('timeout')) {
      Toast.fail('请求超时，请检查网络')
    } else {
      Toast.fail('网络异常，请检查网络连接')
    }
    return Promise.reject(error)
  }
)

export default service
